import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserAccrualState } from "./types";

const initialState: UserAccrualState = {
    isUserAccrualModalOpen: false,
    currentUser: {
        id: "",
    },
    onAccrual: null
}

interface OpenUserAccrualModal {
    data: { id: string }
    onSuccess?: () => void
}

const userAccrualSlice = createSlice({
    name: 'userAccrual',
    initialState,
    reducers: {
        openUserAccrualModal: (state, action: PayloadAction<OpenUserAccrualModal>) => {
            state.isUserAccrualModalOpen = true
            state.currentUser = action.payload.data
            state.onAccrual = action.payload.onSuccess
        },
        closeUserAccrualModal: (state) => {
            state.isUserAccrualModalOpen = false
        },
    }
})

export default userAccrualSlice.reducer
export const { 
    closeUserAccrualModal,
    openUserAccrualModal
} = userAccrualSlice.actions